export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-greece-a159e8fdd86c1379ea45157f123a1e8f.jpg";